import { render } from "./CatalogAttributeSelect.vue?vue&type=template&id=b5cd95c0"
import script from "./CatalogAttributeSelect.vue?vue&type=script&lang=js"
export * from "./CatalogAttributeSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__